module.exports = __webpack_public_path__ + "img/SH2D_300007.8438288b.png";